export default "__VITE_ASSET__MJZ8XEJH__"